import { Injectable, NgZone, inject } from '@angular/core';
import Clarity from '@microsoft/clarity';
import { environment } from '../environments/environment';
import { NGXLogger } from 'ngx-logger';

@Injectable({
  providedIn: 'root',
})
export class ClarityService {
  private zone = inject(NgZone);
  private logger = inject(NGXLogger);


  isEnabled = false;

  constructor() {
    if (!environment.OPTIMISATION_CLARITY) {
      this.logger.warn('Clarity project ID is not set');
      return;
    }
    this.isEnabled = true;
    this.initialise();
  }

  public start() {
    if (!this.isEnabled) {
      this.logger.log('Clarity is not enabled, ignoring start()');
      return;
    }
    this.initialise();
  }

  private initialise() {
    this.logger.log('ClarityService:initialise');
    this.zone.runOutsideAngular(() => {
      if (environment.OPTIMISATION_CLARITY) {
        Clarity.init(environment.OPTIMISATION_CLARITY);
      }
    });
  }

  public identify(customId: string, customSessionId?: string, customPageId?: string, friendlyName?: string) {
    if (!this.isEnabled) {
      this.logger.log('Clarity is not enabled, ignoring identify()');
      return;
    }
    /*
     - Clarity securely hashes the customeId on the client before being sent to Clarity servers.
     - For optimal user tracking, the Identify API should be called for each page of the website even if you are not passing a custom-session-id or custom-page-id.
       TODO : Adde route events to update the identify as per the second point above
     */
    this.zone.runOutsideAngular(() => {
      Clarity.identify(customId, customSessionId, customPageId, friendlyName);
    });
  }

  public setTag(tag: string, value: string) {
    if (!this.isEnabled) {
      this.logger.log('Clarity is not enabled, ignoring setTag()');
      return;
    }
    this.zone.runOutsideAngular(() => {
      Clarity.setTag(tag, value);
    });
  }

  public event(eventName: string) {
    if (!this.isEnabled) {
      this.logger.log('Clarity is not enabled, ignoring event()');
      return;
    }
    this.zone.runOutsideAngular(() => {
      Clarity.event(eventName);
    });
  }

  public consent(hasConsent: boolean) {
    if (!this.isEnabled) {
      this.logger.log('Clarity is not enabled, ignoring consent()');
      return;
    }
    this.zone.runOutsideAngular(() => {
      Clarity.consent(hasConsent);
    });
  }

  public upgrade(reason: string) {
    if (!this.isEnabled) {
      this.logger.log('Clarity is not enabled, ignoring upgrade()');
      return;
    }
    this.zone.runOutsideAngular(() => {
      Clarity.upgrade(reason);
  });
  }
}
